export const tagsMap = {
    'Session Type': 'session_type',
    'Session Marketing': 'session_marketing',
    'Session Sales': 'session_sales',
    'Session Customer Success': 'session_customer_success',
    'Session Culture & Trends': 'session_culture_trends',
    'Session GTM Data & Systems': 'session_gtm_data_systems',
    'Session RevOps': 'session_revops',
    'Session HubSpot Products': 'session_hubspot_products',
    'Session Networking': 'session_networking',    
    'Content Focus': 'session_content_focus',
    'Speaker Type': 'speaker_type',
};

export const tagsSessionMap = {
    'Session Type': 'session_type',
    'Content Focus [Marketing]': 'session_marketing',
    'Content Focus [Sales]': 'session_sales',
    'Content Focus [Customer Success]': 'session_customer_success',
    'Content Focus [Culture & Trends]': 'session_culture_trends',
    'Content Focus [GTM Data & Systems]': 'session_gtm_data_systems',
    'Content Focus [RevOps]': 'session_revops',
    'Content Focus [Hubspot Products]': 'session_hubspot_products',
    'Content Focus [Networking]': 'session_networking',
};

export const sessionTagGroupNames = {
    'session_type': 'Session Type',
    'session_marketing': 'Marketing',
    'session_sales': 'Sales',
    'session_customer_success': 'Customer Success',
    'session_culture_trends': 'Culture & Trends',
    'session_gtm_data_systems': 'GTM Data & Systems',
    'session_revops': 'RevOps',
    'session_hubspot_products': 'HubSpot Products',
    'session_networking': 'Networking',
};

export const tagsSessionMapArray = [
    'session_type',
    'session_marketing',
    'session_sales',
    'session_customer_success',
    'session_culture_trends',
    'session_gtm_data_systems',
    'session_revops',
    'session_hubspot_products',
    'session_networking'
];

export const tagsFilterHandles = {
    Marketing: 'session_marketing',
    Sales: 'session_sales',
    'Customer Success': 'session_customer_success',
    'Culture & Trends': 'session_culture_trends',
    'GTM Data & Systems': 'session_gtm_data_systems',
    RevOps: 'session_revops',
    'HubSpot Products': 'session_hubspot_products',
    Networking: 'session_networking',
};

export const sponsorLevelMap = {
    Premium: 1,
    Remarkable: 2,
    Inspirational: 3,
    Memorable: 4,
    Standard: 5,
    'Friends of INBOUND': 6,
    'No Label': 7,
};

export const speakerFieldMap = {
    email: 'Speaker Profile Email [Bizzabo]',
    firstName: 'Speaker Name',
    lastName: 'Speaker Name',
    title: 'Job Title',
    country: 'Country',
    summary: 'Bio',
    company: 'Company',
    hidden: 'Visibility',
    web: 'Website',
    twitter: 'Twitter Handle',
    linkedinPage: 'LinkedIn Page',
};

export const sponsorFieldMap = {
    // Field map from Bizaboo to Airtable
    logo: 'Sponsor Logo',
    name: 'Sponsor Name',
    visible: 'Visibility',
    website: 'Sponsor Website',
    level: 'Tier',
    booth: 'Booth',
    promotedOffer: 'Special Offer',
    description: 'Sponsor Description',
    contactPhone: 'Contact Phone',
    contactEmail: 'Contact Email',
    twitter: 'Twitter Handle',
    facebook: 'Facebook Page',
    linkedin: 'LinkedIn Page',
    button1: 'Custom Button 1 Name',
    button1Link: 'Custom Link 1',
    button2: 'Custom Button 2 Name',
    button2Link: 'Custom Link 2',
    positionInList: 'Sort Order',
};

export const speakerRoleMap = {
    'Moderator (Unsponsored)': 'Moderator',
    'Moderator (Sponsored)': 'Moderator',
    Host: 'Moderator',
};
